import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { EventCard } from '../../../components/cards';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { showCompleteRegistration } from '../../../utils/events';
import { eventStateTypeIds, sportTypeIds } from '../../../utils/eventConstants';
import { sortEventsByStartDateAsc } from '../../../utils/sorting';

const MyManagedEvents = ({ eventsOrganizing, auth, title, showTennisContent, showPickleballContent }) => {
    const [showAll, setShowAll] = useState();

    const eventsInProgress = [];
    const upcomingEvents = [];

    eventsOrganizing.forEach(event => {
        if (event.eventSchedule?.eventStartUtc && ((showTennisContent && event.sportTypeId === sportTypeIds.TENNIS) || (showPickleballContent && event.sportTypeId === sportTypeIds.PICKLEBALL))) {
            if (event.eventState?.id === eventStateTypeIds.IN_PROGRESS) {
                eventsInProgress.push(event);
            } else if (event.eventState?.id < eventStateTypeIds.IN_PROGRESS) {
                upcomingEvents.push(event);
            }
        }
    });

    const sortedEvents = [
        ...eventsInProgress.sort(sortEventsByStartDateAsc),
        ...upcomingEvents.sort(sortEventsByStartDateAsc),
    ];

    return (
        <>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={title} data-testid="dashboard.my-managed-events.section-heading" />
                        {sortedEvents?.length > 3 && (
                            <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid="dashboard.my-managed-events.view-toggle">
                                {showAll ? 'View Less' : 'View All'}
                            </div>
                        )}
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {sortedEvents.map((event, i) => {
                    if (i <= 2 || (i > 2 && showAll)) {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={event.id}
                            >
                                <EventCard
                                    event={event}
                                    auth={auth}
                                    force={{
                                        cardView: true,
                                    }}
                                    isOnDashboard={true}
                                    showCompleteRegistration={showCompleteRegistration(event, auth.user?.claimedPlayer?.playerId)}
                                    data-testid={`dashboard.my-managed-events.item-${event.id}`}
                                />
                            </div>
                        );
                    }
                    return <div />;
                })}
            </div>
        </>
    );
};

MyManagedEvents.propTypes = {
    eventsOrganizing: PropTypes.instanceOf(Array),
    auth: PropTypes.objectOf(any).isRequired,
    title: PropTypes.string,
    showTennisContent: PropTypes.bool,
    showPickleballContent: PropTypes.bool,
};
MyManagedEvents.defaultProps = {
    eventsOrganizing: [],
    title: '',
    showTennisContent: true,
    showPickleballContent: true,
};

export default MyManagedEvents;
